export default __webpack_public_path__ + "5c210093630fe230c462de91d2ca2b13.ttf";